import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ProfileEditorDrawerSkillsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  padding: 37px 24px 37px 32px;

  ${BREAKPOINTS.tablet} {
    padding: 16px;
  }
`;

export const ProfileEditorDrawerSkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProfileEditorDrawerSkillsPickedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 38px;
`;

export const ProfileEditorDrawerSkillsPickedEmptyLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  align-self: flex-start;

  color: rgba(23, 28, 51, 0.5);
`;

export const ProfileEditorDrawerSkillsTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ProfileEditorDrawerSkillsTitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProfileEditorDrawerSkillsTitle = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  color: var(--color-text);
`;

export const ProfileEditorDrawerSkillsSubtitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: #000;
`;

export const ProfileEditorDrawerSkillsInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const ProfileEditorDrawerSkillsSuggestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 30px 8px;

  background: #ffffff;
  box-shadow: 5px 0px 20px 10px rgba(50, 63, 93, 0.1);
  border-radius: 10px;
`;

export const ProfileEditorDrawerSkillsSuggestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const ProfileEditorDrawerSkillsSuggestionTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: #000;
`;

export const ProfileEditorDrawerSkillsSuggestion = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: end;

  color: var(--color-data-skill-foreground);

  cursor: pointer;
`;

//HEADER
export const ProfileEditorDrawerSkillsHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const ProfileEditorDrawerSkillsHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const ProfileEditorDrawerSkillsHeaderDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(23, 28, 51, 0.5);
`;

//FEELING STUCK
export const ProfileEditorDrawerSkillsFeelingStuckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 22.5px;

  margin: 51px 0px 102px 0px;

  background: rgba(156, 202, 255, 0.2);
  border-radius: 10px;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }

  ${BREAKPOINTS.tablet} {
    padding: 30px 13px;
    margin: 32px 0px 32px 0px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckTitle = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: 31px;

  color: #000000;
`;

export const ProfileEditorDrawerSkillsFeelingStuckContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 48px 12px 40px;

  border: 2px solid var(--color-primary);
  border-radius: 100px;

  & > :not(:last-child) {
    margin-right: 10px;
  }

  transition: background 0.2s ease-in-out;
  &:hover {
    background: var(--color-data-people-background-secondary);
  }

  ${BREAKPOINTS.tablet} {
    padding: 12px 32px 12px 24px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckButtonText = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: var(--color-text);
`;

export const ProfileEditorDrawerSkillsFeelingStuckCloseContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  position: absolute;
  top: 10px;
  right: 10px;

  cursor: pointer;
`;

// FEELING STUCK - RANDOM

export const ProfileEditorDrawerSkillsFeelingStuckRandomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > :not(:last-child) {
    margin-bottom: 24px;
  }

  position: relative;

  ${BREAKPOINTS.tablet} {
    min-width: unset;
    width: 100%;
    padding: 40px 8px 24px 8px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckRandomTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  letter-spacing: 0.1em;
  text-transform: uppercase;

  color: #000000;
`;

export const ProfileEditorDrawerSkillsFeelingStuckRandomPillsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;

export const ProfileEditorDrawerSkillsFeelingStuckRandomShowMoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  margin: 0 auto;

  & > :not(:last-child) {
    margin-right: 17px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckRandomShowMoreText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  color: #000000;

  cursor: pointer;
`;

// FEELING STUCK - ALL
export const ProfileEditorDrawerSkillsFeelingStuckAllContainer = styled.div`
  min-width: 426px;

  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;

  & > :not(:last-child) {
    margin-bottom: 24px;
  }

  ${BREAKPOINTS.tablet} {
    min-width: unset;
    width: 100%;
    padding: 40px 8px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckAllCategoriesContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > :not(:last-child) {
    margin-right: 13px;

    ${BREAKPOINTS.tablet} {
      margin-right: 8.5px;
    }
  }
`;

interface ProfileEditorDrawerSkillsFeelingStuckAllCategoryProps {
  current: boolean;
}

export const ProfileEditorDrawerSkillsFeelingStuckAllCategory = styled.span<ProfileEditorDrawerSkillsFeelingStuckAllCategoryProps>`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${({ current }) =>
    current ? 'var(--color-text)' : 'var(--color-data-community-background-hover)'};
  cursor: pointer;

  ${BREAKPOINTS.tablet} {
    font-size: 15px;
  }
`;

export const ProfileEditorDrawerSkillsFeelingStuckAllPillsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`;

// BOTTOM
export const ProfileEditorDrawerSkillsBottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 10px;
  }
`;

interface ProfileEditorDrawerSkillsBottomTextProps {
  reachedMax: boolean;
}

export const ProfileEditorDrawerSkillsBottomText = styled.span<ProfileEditorDrawerSkillsBottomTextProps>`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: ${({ reachedMax }) => (reachedMax ? 'var(--color-error)' : '#000000')};
`;

// TYPE SWITCHER
export const ProfileEditorDrawerSkillsTypeSwitcherWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;

  padding: 0px 10px 0px 32px;

  backdrop-filter: blur(10px);
`;

export const ProfileEditorDrawerSkillsTypeSwitcherContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  padding: 8px 0 16px 0;

  cursor: pointer;

  position: relative;
`;

export const ProfileEditorDrawerSkillsTypeSwitcherUnderline = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--color-primary);
`;

interface ProfileEditorDrawerSkillsTypeSwitcherLabelProps {
  current: boolean;
}

export const ProfileEditorDrawerSkillsTypeSwitcherLabel = styled.span<ProfileEditorDrawerSkillsTypeSwitcherLabelProps>`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: ${({ current }) => (current ? 'var(--color-text)' : 'rgba(23, 28, 51, 0.50)')};
`;
